import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import door1 from "./components/door-1";
import door2 from "./components/door-2";
import window1 from "./components/window-1";
import window2 from "./components/window-2";
import window3 from "./components/window-3";

const principle: Slide = {
  description:
    "Choose between different doors and windows and see the most important data about them. Listen to everyday sounds in their original form and as they would be perceived through a door or a window. Use headphones. Set the volume on your device so that original male voice sounds realistically loud.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Door 1" },
            { name: "Door 2" },
            { name: "Window 1" },
            { name: "Window 2" },
            { name: "Window 3" },
          ],
        },
      ],
      controlsPosition: "top",
      extraContent: [[], [], [], [], []],
      components: [door1, door2, window1, window2, window3],
    },
  },
};

export default principle;
